<template>
	<div class="flex flex-col items-center gap-4 pb-6 font-[Inter]">
		<div class="flex w-full flex-col gap-2 px-6 text-center">
			<h2 class="text-xl leading-7 font-semibold text-[#111827]">
				Is your resume up to date?
			</h2>
			<p class="text-sm leading-5 text-[#6B7280]">
				Your primary resume was last updated
				<span class="font-medium text-[#111827]">{{ daysSinceUpdate }} days ago</span>. AutoApply works best with
				a current resume. It uses your latest experience to tailor each application.
			</p>
		</div>

		<div class="flex w-full max-w-80 flex-col gap-2">
			<Button
				size="lg"
				class="w-full rounded-md"
				@click="store.keepResume"
			>
				Keep This Resume
			</Button>
			<Button
				size="lg"
				variant="ghost"
				class="w-full rounded-md bg-[#F3F4F6] text-[#111827] hover:bg-[#E5E7EB]"
				@click="store.uploadNewResume"
			>
				Upload New Resume
			</Button>
		</div>
	</div>
</template>

<script setup>
import { storeToRefs } from 'pinia';

import { Button } from '../../../components/ui/button';
import { useAutoApplyPromoStore } from '../../../store/auto-apply-promo.store';

const store = useAutoApplyPromoStore();
const { daysSinceUpdate } = storeToRefs(store);
</script>
